import { Component, OnInit } from '@angular/core';
import { Tenant } from '../../../../../express-tRPC/src/api/tenants/types-generic';
import * as xlsx from 'xlsx';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { TrpcService } from '../../services/trpc/trpc.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateInvoiceRequest, InvoiceItem, itemDescription, itemDescriptionRPCResponse, SaveInvoiceCommentsRequestParams, SUREPARKtoParkProMapping } from '../../../../../express-tRPC/src/api/invoices/types';
import { FileSelectEvent } from 'primeng/fileupload';
import { SUREPARKFindMerchant, SUREPARKtoParkProTenantMapping } from '../../../../../express-tRPC/src/api/tenants/types';
import { AuthService } from '../../services/auth/auth.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-sureparkbill-coupons',
  templateUrl: './sureparkbill-coupons.component.html',
  styleUrl: './sureparkbill-coupons.component.scss'
})
export class SUREPARKBillCouponsComponent implements OnInit {

  version = environment.version;
  activeFile = environment.activeFile;

  supportedMimeTypes: string = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/msexcel",
    "application/x-msexcel",
    "application/x-ms-excel",
    "application/x-excel",
    "application/x-dos_ms_excel",
    "application/xls",
    "application/x-xls"
  ].join(",");

  columnNames: any[] = [];
  columnGroup: any = {
    columns: [],
    groupName: "Event Details",
    id: "event_details"
  }
  tableData: any[] = [];
  loading: boolean = true;

  // Indicates when the list of tenants is loading
  isTenantlistLoading: boolean = false;

  // The list of ParkPro tenants that the user can select from to assign a merchant to
  tenants!: Tenant[];
  listDescriptions: itemDescription[] = [];
  filteredTenants!: Tenant[];

  // The number of tenants used for paging.
  totalTenants: number = 0;
  tenantsForm!: FormGroup;
  tenantFormSubmitted: boolean = false;
  currentDate: Date = new Date();

  validationsForm!: FormGroup;
  validationsFormSubmitted: boolean = false;

  invoiceInProgress: boolean = false;
  showValidationSelectionPopup: boolean = false;

  constructor(
    private httpClient: HttpClient,
    private trpcService: TrpcService,
    private messageService: MessageService,
    private fb: FormBuilder,
    public authService: AuthService
  ) {
  }

  ngOnInit() {

    this.trpcService.trpcReady.then((value) => {
      // console.log(`trpcReady then filed`, value);
      this.getTenantList();
      this.getlistDescriptions();
    })

    this.tenantsForm = this.fb.group({
      tenants: this.fb.array([])
    });

    this.validationsForm = this.fb.group({
      validations: this.fb.array([])
    });
  }

  get TenantsFormControlArray() {
    return this.tenantsForm.get('tenants') as FormArray;
  }

  get ValidationsFormControlArray() {
    return this.validationsForm.get('validations') as FormArray;
  }

  getSelectedTenantName(tenant: Tenant) {
    return (tenant.suite + " - " + tenant.account) + " " + tenant.name + " (" + tenant.billto + ")";
  }

  getTenantFormGroup(index: number): FormGroup {
    return this.TenantsFormControlArray.controls[index] as FormGroup;
  }

  getValidationsFormGroup(index: number): FormGroup {
    return this.ValidationsFormControlArray.controls[index] as FormGroup;
  }

  public downloadFile(): Observable<Blob> {
    return this.httpClient.get('https://localhost:4200/assets/Coupon-Status.xlsx',
      { responseType: 'blob' });
  }

  importInvoiceSheet(event: FileSelectEvent) {
    this.clearInvoiceSheetSeletion();

    this.loading = true;
    this.invoiceInProgress = false;
    this.importSUREPARKFile(event.files[0]);
  }

  clearInvoiceSheetSeletion(): void {
    this.messageService.clear();
    this.columnNames = [];
    this.tableData = [];

    this.tenantsForm = this.fb.group({
      tenants: this.fb.array([])
    });

    this.validationsForm = this.fb.group({
      validations: this.fb.array([])
    });
  }

  async readAndParseSUREPARKValidationFile(data: ArrayBuffer) {
    // console.log(`in fileBufferRead`, data.toString('utf8', 0, 20));
    console.log(`in fileBufferRead`, data);

    const workBook = xlsx.read(data, { type: 'buffer', cellNF: true, cellText: false });

    let worksheet = workBook.Sheets[workBook.SheetNames[0]];

    // Got issue with currency type field so changed format for cell
    Object.keys(worksheet).forEach((key, index) => {
      if (worksheet[key]['t'] == "n" && worksheet[key]['z'] == "[$-1010409]General") {
        worksheet[key]['z'] = "General";
      }
      if (worksheet[key]['t'] == "n" && worksheet[key]['z'] == '[$-1010409]"$"#,##0.00;("$"#,##0.00)') {
        worksheet[key]['z'] = '"$"#,##0.00';
      }
    })

    let worksheetData: any = xlsx.utils.sheet_to_json(worksheet, { raw: false, defval: '' });

    let marchentAccount: string = "";
    let marchentAccountIndex: number | undefined = undefined;

    if (worksheetData?.length) {

      //As per sheet format second row would be column
      let worksheetDataColumnsObj = worksheetData[1];

      Object.keys(worksheetDataColumnsObj).forEach((key: any) => {
        if (worksheetDataColumnsObj[key]) {
          this.columnNames.push({ field: worksheetDataColumnsObj[key].toLowerCase().replaceAll(" ", "_"), header: worksheetDataColumnsObj[key], original_key: key });
        }
      });

      //As per sheet format after second row rest of rows will be table data
      let worksheetDataRows = worksheetData.splice(2, worksheetData.length);

      //Map column array with data
      let worksheetDataRowsUpdatedKeys = worksheetDataRows.map((rowData: any) => {
        let row: any = {};
        Object.keys(rowData).forEach((rowDataKeys: string, index: number) => {
          if (this.columnNames[index]) {
            row[this.columnNames[index]['field']] = rowData[rowDataKeys];
          }
        })
        return row;
      });

      worksheetDataRowsUpdatedKeys.forEach(async (data: any) => {

        //Get merchant account name to group it for table

        if (marchentAccount != data['merchant']) {
          marchentAccount = data['merchant'].trim().replace("'", "");
          marchentAccountIndex = (marchentAccountIndex === undefined) ? 0 : (marchentAccountIndex + 1);
          this.TenantsFormControlArray.push(this.fb.group(
            {
              tenant: ['', [Validators.required]],
              merchant_name: [marchentAccount, [Validators.required]],
              invoice_id: [''],
              comments: [''],
              invoice_details: [{}, []]
            }
          ));
        }

        let rowData: any = Object.assign({}, data);

        rowData['merchant_account'] = marchentAccount;
        rowData['merchant_index'] = marchentAccountIndex;
        rowData['invoice_id'] = '';

        this.tableData.push(rowData);
      });

      if (this.columnGroup?.columns?.length) {
        this.columnNames = this.columnNames.filter((column: any) => !this.columnGroup.columns.includes(column.header));
        //Add Extra grouping column
        this.columnNames.push({ field: this.columnGroup.id, header: this.columnGroup.groupName });

        this.tableData.forEach((data: any, index: number) => {
          let columnGroupValue: string = '';
          this.tableData[index][this.columnGroup.id] = {};
          this.columnGroup.columns.forEach((column: string, columnIndex: number) => {
            if (columnIndex == 0) {
              this.tableData[index][this.columnGroup.id]['summary'] = (column + " : " + this.tableData[index][column.toLowerCase().replaceAll(" ", "_")]);
            }
            columnGroupValue += (column + " : " + this.tableData[index][column.toLowerCase().replaceAll(" ", "_")] + "\n");
            delete this.tableData[index][column.toLowerCase().replaceAll(" ", "_")];
          });
          this.tableData[index][this.columnGroup.id]['desciption'] = columnGroupValue;
        });
      }

      //Add Extra static column
      this.columnNames.push({ field: 'invoice_id', header: 'Invoice' });

      let ticketsList: string[] = this.tableData.map((coupon) => coupon['coupon_#']);

      if (ticketsList.length) {
        let ticketsWithInvoice = await this.getTicketInvoiceDataMappingData(ticketsList);

        if (ticketsWithInvoice?.length) {
          ticketsWithInvoice.forEach((ticket: SUREPARKtoParkProMapping) => {
            let matchedTableRowIndex = this.tableData.findIndex((row: any) => row['coupon_#'] == ticket['surepark_ticket_id']);
            if (matchedTableRowIndex !== -1) {
              this.tableData[matchedTableRowIndex]['invoice_id'] = ticket.parkpro_invoice_id;
              const tenantFormGroup = this.getTenantFormGroup(this.tableData[matchedTableRowIndex]['merchant_index']);
              tenantFormGroup.get('invoice_id')?.setValue(ticket.parkpro_invoice_id);
            }
          });
        }
      }

      //Get Tenant mapping and select tenant if found record
      this.tenantsForm.value.tenants.forEach(async (tenant: any, index: number) => {

        //TODO We need to se lid dynamically based on selected location
        let merchantData: SUREPARKFindMerchant = { lid: 0, merchant_name: tenant.merchant_name.trim() };

        let merchantMappingResult = await this.testGetTenantMapping(merchantData);
        if (merchantMappingResult?.length) {
          merchantMappingResult.forEach(async (marchentMappindData: SUREPARKtoParkProTenantMapping) => {
            let matchedTenant = this.tenants.findIndex((tenant: Tenant) =>
              tenant.account == marchentMappindData.account &&
              tenant.suite == marchentMappindData.suite &&
              tenant.lid == marchentMappindData.lid
            );

            if (matchedTenant !== -1) {
              const tenantFormGroup = this.getTenantFormGroup(index);
              tenantFormGroup.get('tenant')?.setValue(this.tenants[matchedTenant]);
              tenantFormGroup.get('tenant')?.disable();

              let getInvoiceCommentsRequestParams: SaveInvoiceCommentsRequestParams = {
                lid: this.tenants[matchedTenant].lid,
                suite: this.tenants[matchedTenant].suite,
                account: this.tenants[matchedTenant].account,
                parkpro_invoice_id: tenantFormGroup.get('invoice_id')?.value,
              }

              let invoiceDetails = await this.getInvoiceDetailsMapping(getInvoiceCommentsRequestParams);
              if (invoiceDetails?.length) {
                let commentsJSON = JSON.parse(invoiceDetails[0].comments);

                tenantFormGroup.get('invoice_details')?.setValue(commentsJSON);

                if (commentsJSON['comments']) {
                  tenantFormGroup.get('comments')?.setValue(commentsJSON['comments']);
                  tenantFormGroup.get('comments')?.disable();
                }
              }
            }
          });

        }
      });

      let marchants_without_validation: any = {};

      console.log(this.listDescriptions);

      this.tableData.forEach((data: any) => {
        if(!data['invoice_id']) {
          let isValidationMatch: boolean = this.listDescriptions.findIndex((desc: itemDescription) => desc.description == data['discount_type']) !== -1;

          if(!isValidationMatch) {
            let isValidationAlreadyAdded : boolean = marchants_without_validation[data.merchant_account];

            if(!isValidationAlreadyAdded) {
              marchants_without_validation[data.merchant_account] = { merchant_account: data.merchant_account, merchant_index: data.merchant_index, description: [ data['discount_type'] ] };
            } else {
              if(!marchants_without_validation[data.merchant_account]['description'].includes(data['discount_type'])) {
                marchants_without_validation[data.merchant_account]['description'].push(data['discount_type']);
              }
            }
          }
        }
      });

      console.log(marchants_without_validation)

      Object.keys(marchants_without_validation).forEach((validation_key: string) => {
        let validationData = marchants_without_validation[validation_key];
            const tenantFormGroup = this.getTenantFormGroup(validationData['merchant_index']).controls['merchant_name'];
            setTimeout(() => {
              tenantFormGroup.setErrors({validationNotFound: validationData['description']});
            });
      })

    }
    this.loading = false;
  }

  async importSUREPARKFile(blob: Blob) {

    const fileBuffer = await blob.arrayBuffer();
    this.readAndParseSUREPARKValidationFile(fileBuffer);

  }

  async getTenantList() {
    // const fn = `getTenantList`;
    // console.log(`${fn}: entry`);

    this.isTenantlistLoading = true;
    let tenantsResult: any = await this.trpcService.trpc.tenant_list.getTenants.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    this.tenants = tenantsResult;
    // console.log("this.tenants is: " + JSON.stringify(this.tenants));
    // console.log("this.tenants is: ", this.tenants);

    let count: any = await this.trpcService.trpc.tenant_list.getTenantsCount.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    const recordCount = Object.values(count[0][0]);
    this.totalTenants = recordCount[0] as number;
    // console.log("this.totalTenants is: " + this.totalTenants);

    this.isTenantlistLoading = false;

  }

  async getlistDescriptions() {
    let listDescriptionsResponse: itemDescriptionRPCResponse | void = await this.trpcService.trpc.invoice.getARTypesDescriptions.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

    if(listDescriptionsResponse) {
      this.listDescriptions = listDescriptionsResponse.data;
    }
  }

  /**
   * Sample function to create an invoice in ParkPro using XML-RPC through tRPC
   */
  async createInvoice(): Promise<void> {
    this.messageService.clear();
    this.tenantFormSubmitted = true;

    this.showValidationSelectionPopup = false;

    // if(!this.tenantsForm.valid) {
    //   //Mark All tenant input as dirty so it turns red of there is any error
    //   for (let index = 0; index < this.TenantsFormControlArray.length; index++) {
    //     const tenantFormGroup = this.getTenantFormGroup(index);
    //     (tenantFormGroup?.get('tenant') as FormGroup)?.markAsDirty();
    //   }
    //   return;
    // }

    this.invoiceInProgress = true;
    //Lets build create invoice API request schema
    let createInvoiceRequest: CreateInvoiceRequest[] = [];

    let marchentsNotBilled: number = 0;
    let marchentsAlreadyBilled: number = 0;

    //Map merchent tickets with tenant

    for (let index = 0; index < this.TenantsFormControlArray.length; index++) {
      const tenantFormGroup = this.getTenantFormGroup(index);

      let customeErrors: any = tenantFormGroup.controls['merchant_name'].errors;

      if(!customeErrors?.['validationNotFound']?.length || (customeErrors?.['validationNotFound']?.length && customeErrors?.['updatedValidation']?.length)) {

        let tenant = tenantFormGroup.value;

        if (tenant.tenant) {

          //Find tickets for every merchant
          let ticketsPerMerchant: any[] = this.tableData.filter((data: any) => data.merchant_account == tenant.merchant_name && !data.invoice_id);

          //We have added new property so if xlsx sheet format gets change we dont have to change backend code to save ticket number for mapping
          ticketsPerMerchant = ticketsPerMerchant.map((data: any) => { data['ticket_number'] = data['coupon_#']; return data });

          //Skip merchant if there is not tickets to generate invoice
          if (ticketsPerMerchant?.length) {

            tenant.invoice_details['comments'] = tenant.comments;
            let ticketsGroupByDiscount: any = {};

            ticketsPerMerchant.forEach((ticket: any) => {
              if(!ticketsGroupByDiscount[ticket.discount_type]) {

                let validationIndex: number = customeErrors?.['validationNotFound']?.indexOf(ticket.discount_type);
                let new_discount_type: string = customeErrors?.['updatedValidation'][validationIndex] || ticket.discount_type;
                if(customeErrors?.['updatedValidation'][validationIndex]) {
                  if(!tenant.invoice_details['associated_rates']) {
                    tenant.invoice_details['associated_rates'] = {};
                  }
                  tenant.invoice_details['associated_rates'][ticket.discount_type] = customeErrors?.['updatedValidation'][validationIndex];
                }

                ticketsGroupByDiscount[ticket.discount_type] = {data: this.listDescriptions.find((desc: itemDescription) => desc.description == new_discount_type), count: 1 };
              } else {
                ticketsGroupByDiscount[ticket.discount_type]['count'] = ticketsGroupByDiscount[ticket.discount_type]['count'] + 1;
              }
            });


            let invoiceValidationItems: InvoiceItem[] = [];

            Object.keys(ticketsGroupByDiscount).forEach((desc: string) =>{
              let descData: any = ticketsGroupByDiscount[desc];
              invoiceValidationItems.push({
                qty: (descData.count).toString(),
                description: descData.data.description,
                textDescription: '',
                unitprice: String(parseFloat(descData.data.unitprice.replace('$', ''))), //Remove all $ and decimals,
                line_ar_type: descData.data.type
              })
            });

            let merchantInvoice: CreateInvoiceRequest = {
              tickets: ticketsPerMerchant,
              tenant: tenant.tenant,
              comments: JSON.stringify(tenant.invoice_details),
              params: {
                'type': 'Monthly',
                'suite': tenant.tenant.suite.toString(),
                'invoicenotes': tenant.comments,
                'accountnumber': tenant.tenant.account.toString(),
                'billingMonth': this.currentDate.toLocaleString('default', { month: 'long' }) + "-" + this.currentDate.getFullYear(),
                'date': this.currentDate.toLocaleDateString("en-US"),
                'items': invoiceValidationItems
              }
            }
            createInvoiceRequest.push(merchantInvoice);
          } else {
            //If invoice already created then consider merchant as already billed
            marchentsAlreadyBilled++;
          }
        } else {
          //If tenant not selected then consider merchant as not billed
          marchentsNotBilled++;
        }
      } else {
        //If validation description not found then consider merchant as not billed
        marchentsNotBilled++;
      }
    }

    console.log(createInvoiceRequest)


    if (createInvoiceRequest.length) {

      let invoiceResult: any = await this.trpcService.trpc.invoice.createInvoice.mutate(createInvoiceRequest).catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });

      if (invoiceResult) {
        console.log(invoiceResult)
        if (invoiceResult?.length) {
          let successInvoice: any[] = invoiceResult.filter((result: any) => result.data[0] == "Success");
          let failedInvoice: any[] = invoiceResult.filter((result: any) => result.data[0] != "Success");
          if (successInvoice?.length) {
            this.messageService.add({
              severity: "success",
              detail: (successInvoice?.length + " invoice generated."),
            });
          }
          if (failedInvoice?.length) {
            this.messageService.add({
              severity: "error",
              detail: (failedInvoice?.length + " invoice failed."),
            });
          }
          if (marchentsAlreadyBilled) {
            this.messageService.add({
              severity: "info",
              detail: (marchentsAlreadyBilled + " merchants previously billed."),
            });
          }
          if (marchentsNotBilled) {
            this.messageService.add({
              severity: "warn",
              detail: (marchentsNotBilled + " merchants not billed."),
            });
          }

          invoiceResult.forEach((result: any) => {

            if (result?.data?.length) {
              if (result.data[0] === 'Success') {
                this.tableData.forEach((data: any, index: number) => {
                  if (data.merchant_account == result.merchant_account && !data.invoice_id) {
                    this.tableData[index]['invoice_id'] = result.data[2];
                  }
                })
              }
            }
          });
        }
      }
      this.invoiceInProgress = false;
    } else {
      this.messageService.add({
        severity: "error",
        detail: "No tickets found for invoice.",
      });
      this.invoiceInProgress = false;
    }
  }

  checkValidationAndShowPopup() {

    this.validationsForm = this.fb.group({
      validations: this.fb.array([])
    });

    let showPopup: boolean = false;
    let uniqueValidation: string[] = [];
    for (let index = 0; index < this.TenantsFormControlArray.length; index++) {
      const tenantFormGroup = this.getTenantFormGroup(index);
      let tenant = tenantFormGroup.value;

      if (tenant.tenant) {
        if(tenantFormGroup.controls['merchant_name'].errors?.['validationNotFound']?.length) {
          showPopup = true;

          let validations: string[] = tenantFormGroup.controls['merchant_name'].errors?.['validationNotFound'];

          for (let validationIndex = 0; validationIndex < validations.length; validationIndex++) {
            const validation = validations[validationIndex];
            if(!uniqueValidation.includes(validation)) {
              this.ValidationsFormControlArray.push(this.fb.group(
                {
                  validation: [validation, [Validators.required]],
                  updated_validation: ['', [Validators.required]],
                }
              ));
              uniqueValidation.push(validation);
            }

          }

        }
      }
    }

    this.showValidationSelectionPopup = showPopup;
    if(!this.showValidationSelectionPopup) {
      this.createInvoice();
    }
  }

  updateValidations(): void {
    this.validationsFormSubmitted = !this.validationsForm.valid;

    if(!this.validationsForm.valid) {
      for (let index = 0; index < this.ValidationsFormControlArray.length; index++) {
        const validationFormGroup = this.getValidationsFormGroup(index);
        (validationFormGroup?.get('updated_validation') as FormGroup)?.markAsDirty();
      }
      return;
    }

    if(this.validationsForm.valid) {
      for (let index = 0; index < this.TenantsFormControlArray.length; index++) {
        const tenantFormGroup = this.getTenantFormGroup(index);

        this.validationsForm.value['validations'].forEach((validation: any) => {
          if(validation['updated_validation']) {

            let validations: string[] = tenantFormGroup.controls['merchant_name'].errors?.['validationNotFound'];
            let updated_validations: string[] = tenantFormGroup.controls['merchant_name'].errors?.['updatedValidation'] || [];

            for (let validationIndex = 0; validationIndex < validations?.length; validationIndex++) {
              const val = validations[validationIndex];
              if(validation['validation'] == val) {
                updated_validations.push(validation['updated_validation']['description'])
              }
            }

            tenantFormGroup.controls['merchant_name'].setErrors({validationNotFound: validations, updatedValidation: updated_validations})
          }
        });
      }
    }

    setTimeout(() => {
      this.showValidationSelectionPopup = false;
      this.createInvoice();
    }, 0);
  }

  resetTenantList(): void {
    this.filteredTenants = this.tenants;
  }

  filterTenant(event: AutoCompleteCompleteEvent): void {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.tenants as any[]).length; i++) {
      let tenant = (this.tenants as any[])[i];
      if (
        tenant.name.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        tenant.account == query || tenant.suite == query ||
        tenant.billto.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(tenant);
      }
    }

    this.filteredTenants = filtered;
  }

  async getTicketInvoiceDataMappingData(tickets: string[]) {
    let ticketsWithInvoice = await this.trpcService.trpc.invoice.getSUREPARKtoParkProMapping_post.mutate(tickets).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

    return ticketsWithInvoice;

  }

  async getInvoiceDetailsMapping(params: SaveInvoiceCommentsRequestParams) {
    let invoiceWithDetails = await this.trpcService.trpc.invoice.getSUREPARKtoParkProInvoiceDetailsMapping_post.mutate(params).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

    return invoiceWithDetails;

  }

  /**
   * Simple function to get the mapping of the SUREPARK merchant name for a given ParkPro location (if set)
   */
  async testGetTenantMapping(sureparkMerchant?: SUREPARKFindMerchant) {

    // When loading the list of invoices check if the merchant name is already mapped to a tenant

    let sureparkMerchantToFind!: SUREPARKFindMerchant;

    // if no merchant data provided then use dummy merchant data for testing purpose only
    sureparkMerchantToFind = sureparkMerchant || { lid: 99999, merchant_name: 'Test Merchant' };

    let results: any = await this.trpcService.trpc.tenant_list.
      getSUREPARKtoParkProTenantMapping_post.mutate(sureparkMerchantToFind).catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });

    console.log("mapping results: ", results);

    return results;

  }

  async testReloadOpenInvoices() {

    // console.log(`Entered testReloadOpenInvoices`)

    //

    let lid = await this.trpcService.trpc.lots.getSessionLID.query()
      .then((data: any) => {
        return data;
      })
      .catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });


    console.log(lid);

    await this.trpcService.trpc.invoice.reloadOpenInvoices.query(lid).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

  }

  async testSimulateError() {

    // console.log(`Entered testSimulateError`)

    await this.trpcService.trpc.dev.simulateError.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });

  }

  async testGetTime() {

    // console.log(`Entered testSimulateError`)

    await this.trpcService.trpc.dev.getTime.query()
      .then((data: any) => {
        console.log(data);
      })
      .catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });

  }

  async testGetLID() {

    // console.log(`Entered testSimulateError`)

    await this.trpcService.trpc.lots.getSessionLID.query()
      .then((data: any) => {
        console.log(data);
      })
      .catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });

  }


  /**
   * Sample function to create a mapping for a specific SUREPARK merchant name to a given ParkPro account
   */
  async testCreateTenantMapping() {

    // TODO Supply with user select mapping
    let sureparkMerchantMapping: SUREPARKtoParkProTenantMapping = {
      lid: 99999,
      suite: 500,
      account: 1002,
      merchant_name: 'Test Merchant'
    };

    let invoiceResult: any =
      await this.trpcService.trpc.tenant_list.createSUREPARKtoParkProTenantMapping.mutate(sureparkMerchantMapping)
        .catch((error: any) => {
          this.messageService.add({
            severity: "error",
            detail: error.message,
          });
        });

  }


}
